import * as LangStyles from './components/Lang.css';

export default {
	LangStyles
};
